export const BILLING_MODE_OPTIONS = [
  { value: 'PERSONAL_FIXED', label: '个人固定订阅' },
  { value: 'ORG_FIXED', label: '组织固定订阅' },
  { value: 'ORG_SEAT', label: '组织席位订阅' },
  { value: 'ORG_PACKAGE', label: '组织套餐订阅' },
  { value: 'ORG_CUSTOM', label: '企业定制' }
]

export function billingModeLabel (value) {
  const item = BILLING_MODE_OPTIONS.find(option => option.value === value)
  return item ? item.label : (value || '-')
}

export const LLM_QUOTA_POLICY_OPTIONS = [
  { value: 'PAY_AS_YOU_GO', label: '额度不足后扣无限积分' },
  { value: 'BLOCK', label: '额度不足后拒绝使用' }
]

export function llmQuotaPolicyLabel (value) {
  const item = LLM_QUOTA_POLICY_OPTIONS.find(option => option.value === value)
  return item ? item.label : (value || '-')
}

export function ownerTypeLabel (value) {
  const labels = {
    PERSONAL: '个人',
    ORGANIZATION: '组织',
    MERCHANT: '商家'
  }
  return labels[String(value || '').toUpperCase()] || value || '-'
}

export function targetTypeLabel (value) {
  return ownerTypeLabel(value)
}

export function changeTypeLabel (value) {
  const labels = {
    GRANT: '入账',
    RESERVE: '消费扣减',
    COMMIT: '确认消费',
    RELEASE: '退回',
    EXPIRE: '过期'
  }
  return labels[String(value || '').toUpperCase()] || value || '-'
}

export function businessTypeLabel (value) {
  const labels = {
    NANO_BANANA: '图片生成',
    VIDEO_GENERATION: '视频生成',
    CREDIT_RECHARGE: '无限积分充值',
    CANVAS_SUBSCRIPTION: '无限权益订阅',
    AI_SUBSCRIPTION: '无限权益订阅',
    DAILY_GRANT: '每日赠送无限积分'
  }
  return labels[String(value || '').toUpperCase()] || value || '-'
}

export function sourceTypeLabel (value) {
  const labels = {
    ADMIN_GRANT: '后台发放',
    RECHARGE: '充值购买',
    SUBSCRIPTION_GRANT: '订阅开通赠送',
    SUBSCRIPTION_DAILY: '订阅每日赠送',
    SYSTEM: '系统',
    ORDER: '订单',
    REFUND: '退回'
  }
  return labels[String(value || '').toUpperCase()] || value || '-'
}

export function sanitizeAiText (value) {
  return String(value || '')
    .replace(/AI\s*权益/g, '无限权益')
    .replace(/AI\s*积分/g, '无限积分')
    .replace(/AI\s*订阅/g, '无限权益订阅')
}

export function hasRawModelName (value) {
  const normalized = String(value || '').toLowerCase()
  return [
    'nano banana',
    'nano-banana',
    'banana',
    'gemini',
    'kling',
    'hailuo',
    'pollo',
    '可灵',
    '海螺'
  ].some(keyword => normalized.includes(keyword))
}

export function ledgerTitleLabel (row = {}) {
  const businessLabel = businessTypeLabel(row.businessType)
  const rawTitle = String(row.title || '').trim()
  if (!rawTitle) return businessLabel
  if (hasRawModelName(rawTitle)) return businessLabel || '生成消耗'
  return sanitizeAiText(rawTitle)
}
